import { PUSH_POPUP, POP_POPUP } from './constants';

export const pushPopup = popup => ({ type: PUSH_POPUP(), popup });
export const popPopup = () => ({ type: POP_POPUP() });
